import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { retailerContactRouter } from './routing/retailerContactRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'retailer-contact',
  totem: {
    tool: 'retailer-contact-dashboard-tool',
  },
  routes,
  translations: {},
  lazyTranslations: {
    EN_US: () => import('./translations/en-US.json'),
  },
  routers: {
    scoped: [retailerContactRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [],
}

export default definition
